import { PAYMENT_PART } from "enums/paymentParts";
import { CHAIN_IDS } from "enums/chainIds";
import { PRODUCT_TYPES } from "enums/productTypes";

export const STORE_VERSIONS = {
  1: 1,
  2: 2,
};

export const LOW_BALANCE_EMAIL = "mateusz.chrzanowski@uniqly.io";
export const LOW_BALANCE_THRESHOLD = 50; //Matic
export const MAX_PRODUCTS = 50;
export const MAX_BOX_CAPACITY = 3;
export const DEFAULT_USD_PLN = 4.4;

export const MIN_FIAT_AMOUNT = {
  USD: 5,
  PLN: 20,
}; // USD
export const MAX_FIAT_AMOUNT = {
  USD: 250,
  PLN: 1000,
}; // USD
export const FIAT_FEE = 3; // PERCENTAGE
export const UNIQ_STORE_PAYMENT_DISCOUNT = 0.5; // PERCENTAGE

// Currency: ETH
export const PRICES = {
  [PAYMENT_PART.DURATION]: 0.05, // PER MONTH
  [PAYMENT_PART.CUSTOM_TOKEN]: 0.1,
  [PAYMENT_PART.EMBEDDED]: 0,
  [PAYMENT_PART.SUBDOMAIN]: 0,
};

export const MB_SIZE = 1048576; // 1MB
export const STORES_EMAIL = "stores@uniqly.io"; // DCL request, custom token request
export const STORE_PAID_EMAILS = [
  "stores@uniqly.io",
  "jakub@uniqly.io",
  "joanna@uniqly.io",
]; // STORE PAID

export const PRODUCT_MIN_PRICES = {
  [PRODUCT_TYPES.T_SHIRT]: 14.99,
  [PRODUCT_TYPES.HOODIE]: 39.99,
};

export const PRODUCT_PRINT_PRICE = 5;

export const BACKWARD_COMPATIBILITY_PRINTS_NUMBER = 2;

export const ADDITIONAL_STORES = [
  {
    name: "Cyber Kongz Play&Kollect",
    url: "cyberkongz-play",
    description:
      "Hoodies designed to celebrate the launch of Play & Kollect and are exclusively distributed through the game in collaboration with Uniqly.io! Kongz together strong!",
    banner: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/stores/additional-stores/kongz-750x374.png`,
    avatar: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/stores/additional-stores/kongz-avatar.png`,
    tileImage: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/stores/additional-stores/kongz-avatar.png`,
    chainIds: [CHAIN_IDS.POLYGON_MAINNET, CHAIN_IDS.POLYGON_TESTNET],
  },
  {
    name: "Encyklopedia Kryptowalut",
    url: "encyklopedia-kryptowalut",
    description:
      "he special NFT T-shirt of Encyklopedia Kryptowalut x Uniqly was a reward for all presale participants that joined through the dedicated whitelist for the Encyklopedia Kryptowalut community. Each Uniqly NFT is redeemable for the physical item with full Proof of Authenticity.",
    banner: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/stores/additional-stores/encyklopedia-750x374.png`,
    avatar: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/stores/additional-stores/encyklopedia-avatar.png`,
    tileImage: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/stores/additional-stores/encyklopedia-avatar.png`,
    chainIds: [CHAIN_IDS.MAIN, CHAIN_IDS.SEPOLIA],
  },
  {
    name: "Jarzombek",
    url: "Jarzombek",
    description:
      "The special NFT poster of Jarzombek x Uniqly was a reward for lucky Youtube contest participants. Given to the most committed members of the Jarzombek community. Each Uniqly NFT is redeemable for the physical item with full Proof of Authenticity.",
    banner: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/stores/additional-stores/jarzombek-750x374.png`,
    avatar: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/stores/additional-stores/jarzombek-avatar.png`,
    tileImage: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/stores/additional-stores/jarzombek-avatar.png`,
    chainIds: [CHAIN_IDS.MAIN, CHAIN_IDS.SEPOLIA],
  },
  {
    name: "NFTHub",
    url: "nfthub",
    description:
      "Limited Edition physical T-Shirt - a part of the Nonfungible Fashion Genesis drop by NFThub x Uniqly. Redeemable through Uniqly's proof-of-burn protocol for a physical items permanently linked to this NFT.",
    banner: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/stores/additional-stores/nfthub-750x374.png`,
    avatar: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/stores/additional-stores/nfthub-avatar.png`,
    tileImage: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/stores/additional-stores/nfthub-avatar.png`,
    chainIds: [CHAIN_IDS.MAIN, CHAIN_IDS.SEPOLIA],
  },
  {
    name: "Uniqly Collection",
    url: "uniqly",
    description:
      "A merge of exclusive Uniqly NFTs created in collaboration with Uniqly partners, or as a reward for the community members for various activities. Each Uniqly NFT is redeemable for the physical item with full Proof of Authenticity and. metaverse wearable.",
    banner: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/stores/additional-stores/uniq-collection-750x374.png`,
    avatar: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/stores/additional-stores/uniq-collection-avatar.png`,
    tileImage: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/stores/additional-stores/uniq-collection-avatar.png`,
    chainIds: [CHAIN_IDS.MAIN, CHAIN_IDS.SEPOLIA],
  },
  {
    name: "Uniqly Genesis",
    url: "uniqly-genesis",
    description:
      "An exclusive collection of 5800 randomly generated NFT shirt-shaped jellies. Each of the items can be redeemed for the corresponding physical item and metaverse wearable. By holding Uniqly NFT you have the right to both - the digital product and underlying real-world item.",
    banner: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/stores/additional-stores/uniq-genesis-750x374.png`,
    avatar: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/stores/additional-stores/uniq-genesis-avatar.png`,
    tileImage: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/stores/additional-stores/uniq-genesis-avatar.png`,
    chainIds: [CHAIN_IDS.MAIN, CHAIN_IDS.SEPOLIA],
  },
  {
    name: "Uniqly Generator",
    url: "uniqly-generator",
    description:
      "Uniqly Generator Collection contains NFTs created in the Uniqly NFT Generator by the community contributors. ",
    banner: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/stores/additional-stores/uniq-generator-750x374.png`,
    avatar: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/stores/additional-stores/uniq-generator-avatar.png`,
    tileImage: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/stores/additional-stores/uniq-generator-avatar.png`,
    chainIds: [CHAIN_IDS.MAIN, CHAIN_IDS.SEPOLIA],
  },
  {
    name: "Uniqly Generator",
    url: "uniqly-generator-polygon",
    description:
      "Uniqly Generator Collection contains NFTs created in the Uniqly NFT Generator by the community contributors. ",
    banner: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/stores/additional-stores/uniq-generato-polygon-750x374.png`,
    avatar: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/stores/additional-stores/uniq-generato-polygon-avatar.png`,
    tileImage: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/stores/additional-stores/uniq-generato-polygon-avatar.png`,
    chainIds: [CHAIN_IDS.POLYGON_MAINNET, CHAIN_IDS.POLYGON_TESTNET],
  },
];
